import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { ADD_SEQUENCE_STEPS, DEFAULT_CONTACT_QUERY_PARAMS } from 'constants/sequence';
import {
  ContactsStartPage,
  ContactsPreview,
} from 'components/modals/SequenceModal';
import { resetPreviewContacts, resetContacts } from 'redux/actions/contactActions';
import { getSequenceContacts } from 'redux/actions/sequenceContactActions';
import NotificationSystem from 'rc-notification';
import BasicNotification from 'components/Notification';
import { NOTIFICATION_NODE_STYLE } from 'constants/misc';


class AddContactSteps extends Component {
  static propTypes = {
    toggleModal: PropTypes.func.isRequired,
    // closeSequenceModal: PropTypes.func.isRequired,
    sequence: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
    }).isRequired,
    getSequenceContacts: PropTypes.func.isRequired,
    campaign: PropTypes.shape({
      id: PropTypes.number,
    }).isRequired,
    handleChangeModalSize: PropTypes.func.isRequired,
    resetPreviewContacts: PropTypes.func.isRequired,
    resetContacts: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.setStep = this.setStep.bind(this);
    this.state = {
      step: ADD_SEQUENCE_STEPS.CONTACTS_START_PAGE,
    };
    this.onAddContactSuccess = this.onAddContactSuccess.bind(this);
  }
  componentDidMount() {
    // eslint-disable-next-line no-return-assign
    NotificationSystem.newInstance({}, n => this.notification = n);
  }

  componentWillUnmount() {
    this.props.resetPreviewContacts();
    this.props.resetContacts();
    this.notification.destroy();
  }

  onAddContactSuccess = async () => {
    const { toggleModal, sequence } = this.props;
    await this.props.getSequenceContacts(sequence.id, {
      ...DEFAULT_CONTACT_QUERY_PARAMS,
    });
    toggleModal();
  }

  setStep(number) {
    this.setState({ step: number });
  }

  showNotification(message) {
    this.notification.notice({
      content: <BasicNotification
        color="danger"
        message={message}
      />,
      duration: 5,
      closable: false,
      style: NOTIFICATION_NODE_STYLE,
      className: 'alert--colored right-up',
    });
  }

  render() {
    const { step } = this.state;
    const { toggleModal, handleChangeModalSize } = this.props;
    return (
      <React.Fragment>
        {step === ADD_SEQUENCE_STEPS.CONTACTS_START_PAGE && (
          <ContactsStartPage
            toggleModal={toggleModal}
            onNext={() => this.setStep(ADD_SEQUENCE_STEPS.CONTACTS_PREVIEW_STEP)}
            setStep={this.setStep}
            handleChangeModalSize={handleChangeModalSize}
          />
        )}
        {step === ADD_SEQUENCE_STEPS.CONTACTS_PREVIEW_STEP && (
          <ContactsPreview
            toggleModal={toggleModal}
            onBack={() => this.setStep(ADD_SEQUENCE_STEPS.CONTACTS_START_PAGE)}
            setStep={this.setStep}
            onSubmit={this.onAddContactSuccess}
            handleChangeModalSize={handleChangeModalSize}
          />
        )}
      </React.Fragment>
    );
  }
}

export default compose(connect(
  state => ({
    sequence: state.sequence,
  }),
  { getSequenceContacts, resetPreviewContacts, resetContacts },
))(AddContactSteps);
